module.exports = __webpack_public_path__ + "img/业务流程.00946da8.png";